import type { ValueFormatterParams } from "ag-grid-community";
import { useFormatMoney } from "~/modules/multi-currency/ui/format-money";
import type { MoneyKind, ReportRow } from "~/utils/types/assistant-report-artifact";

import { formatAssistantDollarAmount, formatAssistantRowMoney } from "./report-field-formatters";

interface AssistantMoneyCellRendererParams extends ValueFormatterParams<ReportRow, unknown> {
  currencyCodeKey?: string;
  moneyKind?: MoneyKind;
}

export const AssistantMoneyCellRenderer = (params: AssistantMoneyCellRendererParams) => {
  const formatOrgMoney = useFormatMoney();
  if (params.currencyCodeKey) {
    return formatAssistantRowMoney(params.value, params.data?.[params.currencyCodeKey], params.moneyKind);
  }
  return formatAssistantDollarAmount(params.value, formatOrgMoney, params.moneyKind);
};
